
export const CLIENT_SET_BROWSER_HISTORY = 'CLIENT_SET_BROWSER_HISTORY'
export const CLIENT_SET = 'CLIENT_SET'
export const CLIENT_UNSET = 'CLIENT_UNSET'
export const CLIENT_CHECK_TOKEN = 'CLIENT_CHECK_TOKEN'
export const CLIENT_CHECK_RIGHT_REQUESTING = 'CLIENT_CHECK_RIGHT_REQUESTING'
export const CLIENT_CHECK_RIGHT_SUCCESS = 'CLIENT_CHECK_RIGHT_SUCCESS'
export const CLIENT_CHECK_RIGHT_ERROR = 'CLIENT_CHECK_RIGHT_ERROR'

export const CLIENT_CHECK_TOKEN_API = '/api/v1/users/check_token_alive'
export const CLIENT_CHECK_RIGHT_API = '/api/v1/users/check_is_admin'



// WEBPACK FOOTER //
// ./src/views/client/constants.js